import {useSelector} from 'react-redux';
import {selectedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {ISlide} from '../../incase-domain/slide';

export const useRules = (): {
    checkIfElementIsUsedInAppliedRules: (elementId: string) => boolean;
    checkIfSlideIsUsedInAppliedRules: (slide: ISlide) => boolean;
} => {
    const {appliedRules} = useSelector(selectedPresentationSelector);

    const checkIfElementIsUsedInAppliedRules = (elementId: string): boolean => {
        if (!appliedRules) return false;
        return appliedRules.some((rule) => {
            return rule.predicates.some((predicate) => {
                return predicate.elementId === elementId;
            });
        });
    };

    const checkIfSlideIsUsedInAppliedRules = (slide: ISlide): boolean => {
        if (!appliedRules) return false;
        return appliedRules.some((rule) => {
            return (
                rule.predicates.some((predicate) => slide.elements.map((el) => el.id).includes(predicate.elementId)) ||
                rule.results.some((result) => result.slideIds.includes(slide._id))
            );
        });
    };

    return {checkIfElementIsUsedInAppliedRules, checkIfSlideIsUsedInAppliedRules};
};
